/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React, { useState, useEffect } from "react";

//@Packages
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Tab, Tabs } from "@forge/common";

//@Components
import DeviceList from "../devicelist";

//@Models
import { TabPanelProps } from "../../models";

//@Store
import { RootState } from "../../store";

//@Actions
import { setHeaderDetails } from "../../actions";

//@Constants
import { LOCALE_CONST, ROUTE_PATH } from "../../utils/constants";

//@Styles
import "./index.scss";

const LandingPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { selectedOrg, customerType } = useSelector((state: RootState) => state.global);

  useEffect(() => {
    dispatch(setHeaderDetails({ headerDetails: { type: '', title: '', status: '' } }));
  }, []);

  const [tabValue, setTabValue] = useState("iotDevice");

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <>{children}</>}
      </div>
    );
  }

  return (
    <>
      <div className={`dashboard-page-header hidden`}>
        <div className="tab-area">
          <Tabs onChange={(id: string) => setTabValue(id)} value={tabValue}>
            <Tab id="iotDevice">{t(LOCALE_CONST.gatewayManagement)}</Tab>
          </Tabs>
        </div>        
        <Button
          className="create-device-button"
          onClick={() => navigate(ROUTE_PATH.createDevice)}
          aria-label="Create"
          disabled={!selectedOrg}
        >
          {t(LOCALE_CONST.create)}
        </Button>
      </div>

      <TabPanel value={tabValue} index="iotDevice">
        <div className={`tab-panel-content ${customerType ? 'p-0' : ''}`}>
          <DeviceList />
        </div>
      </TabPanel>
    </>
  );
};

export default LandingPage;